import React, { useContext } from 'react';

import './index.scss';

import LodingImage from 'assets/loading.svg';
import { PAGE_MAP, FATAL_ERROR_MESSAGES } from 'utils/constant';
import {
  useAnalytics,
} from 'utils';
import AppContext from 'fluxes/context';
import SpHeader from 'components/organisms/SpHeader';
import SpFooter from 'components/organisms/SpFooter';

// SP用のテンプレート
const SpBasicTemplate = ({ 
  path,
  children,
  onClickMainButton,
  valid,
  isApiError,
  showLoading,
}) => {
  const { state } = useContext(AppContext);
  const { title, prevUrl, nextUrl, buttonType } = PAGE_MAP[path];
  
  useAnalytics(); // Web計測
  
  return (
    <div className='SpBasicTemplate'>
      <div className="header">
        <SpHeader 
          title={title}
          state={state}
          path={path}
        />
      </div>
      <div className="children">
        {children}
      </div>
      <div className="footer">
        <SpFooter 
          onClickMainButton={onClickMainButton}
          prevUrl={prevUrl}
          nextUrl={nextUrl}
          buttonType={buttonType}
          valid={valid}
        />
      </div>
      {/* ローディング */}
      {showLoading && (
        <div className="loading-modal-wrapper">
          <div className="loading-modal-wrapper-background">
            <img className="loading-image" src={LodingImage} alt="loading" />
          </div>
        </div>
      )} 
      {/* APIエラーモーダル */}
      {isApiError && (
        <div className="api-error-modal-wrapper">
          <div className="api-error-modal-wrapper-background">
            <div className="api-error-modal">
              {FATAL_ERROR_MESSAGES.map(message => <div key={message}>{message}</div>)}
              <div className="api-error-top-link"><a href="/clcd/odform/">TOPへ戻る</a></div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SpBasicTemplate;